const routeTitleMap: Record<string, string> = {
  "/dashboard": "nav.dashboard",
  "/invoices": "nav.invoices",
  "/addresses": "nav.addresses",
  "/actions": "nav.actions",
  "/analytics": "nav.analytics",
  "/settings": "nav.settings",
  "/admin/settings": "nav.adminSettings",
};

const resolveTitleKey = (pathname: string): string => {
  const exact = routeTitleMap[pathname];
  if (exact) return exact;
  if (pathname.startsWith("/invoices")) return "nav.invoices";
  if (pathname.startsWith("/admin/settings")) return "nav.adminSettings";
  if (pathname.startsWith("/payment")) return "payment:pageTitle";
  if (pathname.startsWith("/scraping")) return "scraping:title";
  if (pathname.startsWith("/meter-readings")) return "meterReadings:pageTitle";
  return "nav.dashboard";
};

export { routeTitleMap, resolveTitleKey };
